import { Fragment } from 'react';
import type { VoidFunctionComponent } from 'react';

import Flex from '../../../../generic/Flex';
import Icon, { icons } from '../../../../generic/Icon';
import Tooltip from '../../../../generic/Tooltip';
import type { Project } from '../../../../../../shared/projectsV2';

type Props = {
  project: Project;
  onClick: (label: string) => void;
};

const ProjectLabels: VoidFunctionComponent<Props> = ({ project, onClick }: Props) => {
  return (
    <div className="project-item__labels">
      <Flex justify="left" align="center" gap="4px">
        <span className="project-item__title_icon project-item__tag">
          <Icon icon={icons.tags} />
        </span>
        {project.labels.map((label, idx) => (
          <Fragment key={label}>
            <Tooltip id="project-label-tooltip" tooltip={label} placement="top">
              <span className="project-item__labels__text" key={label}>
                <a
                  onClick={(e) => {
                    e.stopPropagation();
                    onClick(label);
                  }}>
                  {label}
                </a>
              </span>
            </Tooltip>
            {/* Add a comma after each label except the last. We can't do this in CSS because it will be included in ellipses overflow. */}
            {idx !== project.labels.length - 1 && (<span className="project-item__labels__text--comma">,</span>)}
          </Fragment>
        ))}
      </Flex>
    </div>
  );
};

export default ProjectLabels;
